export const blockIconsImageNavigateNext = (
	<span className='material-symbols-outlined'>navigate_next</span>
);
